/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { campaignUsageRequestDataTypeSchema } from './CampaignUsageRequestDataTypeSchema'

export const campaignUsageRequestDataSchema = z.object({
	type: campaignUsageRequestDataTypeSchema.optional().default('request_more_campaigns'),
	feature: z.string().nullable().optional(),
})

export type CampaignUsageRequestDataSchema = z.infer<typeof campaignUsageRequestDataSchema>
